import PropTypes from 'prop-types'
import { iconSizeOptions } from '../../../../components/stories/atoms/icons/icons-sizes'
import { SpinnerGrey } from '../../../../components/stories/atoms/icons/special'
import SkeletonComponent from '../../../../components/stories/atoms/skeleton'
import { LoaderChildrenItems } from '../../styled-component'

const PlanMenuMobilePlanListLoad = ({ isChildren = false }) => {
  if (isChildren)
    return (
      <LoaderChildrenItems>
        <SpinnerGrey size={iconSizeOptions.MEDIUM} />
      </LoaderChildrenItems>
    )

  return (
    <SkeletonComponent
      elementQuantity={10}
      isLoading
      skeletonShape={{
        width: '100%',
        height: '70px',
        borderRadius: '8px',
        marginBottom: '0.5rem'
      }}
    />
  )
}

PlanMenuMobilePlanListLoad.propTypes = {
  isChildren: PropTypes.bool
}

export default PlanMenuMobilePlanListLoad
